import React from "react";
import { useNetworkStatus } from "./NetworkStatusProvider";
import { useTranslation } from "react-i18next";

export default function OfflineIndicator() {
  const { isOnline, wasOffline } = useNetworkStatus();
  const { t } = useTranslation();

  if (isOnline && !wasOffline) return null;

  return (
    <div
      className={`text-center text-white py-2 px-3 ${isOnline ? "bg-success" : "bg-warning"}`}
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        fontSize: 14,
        transition: "all 0.3s ease"
      }}>
      
      {isOnline ?
      <>
          <i className="ni ni-check-bold mr-1" />
          {t("network.restored", "Connection restored!")}
        </> :

      <>
          <i className="ni ni-notification-70 mr-1" />
          {t("network.offline", "You are offline. Some features may be unavailable.")}
        </>
      }
    </div>);

}
